module.exports = __webpack_public_path__ + "facelifting_3_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/facelifting_3_after.jpg
// module id = 1053
// module chunks = 0